import React, { useState, useEffect, useCallback, useRef } from 'react';

import Me from '../../statics/Curriculum/Sho.webp';

import { useLanguage } from '../../context/LanguageContext';
import LanguageSelector from '../LanguageSelector';

import oceanAudio from '../../statics/Song/Ocean.mp3';

import logo from '../../statics/head.png';

import FormIntake from "./FormIntake";

import menu from "../../statics/menu.png";
//import clock from '../../statics/clock.png';
//import delivery from '../../statics/delivery.png';
//import oils from '../../statics/oils.png';
import promototal from '../../statics/promototal.png';

// Imágenes principales
import image1 from '../../statics/estatic-1.png';
import image2 from '../../statics/estatic-2.png';
import image3 from '../../statics/estatic-3.png';

// Imágenes INACTIVAS
import image1Inactive from '../../statics/estatic-1-inactive.png';
import image2Inactive from '../../statics/estatic-2-inactive.png';
import image3Inactive from '../../statics/estatic-3-inactive.png';

// GIFs animados
import aniImage1 from '../../statics/GIF-1-no-tr.gif';
import aniImage2 from '../../statics/GIF-2-no-tr.gif';
import aniImage3 from '../../statics/GIF-3-no-tr.gif';

// Polaroids y videos
import imgOpcA1 from '../../statics/Curriculum/opcionA/foto-POLAROID1.webp';
import imgOpcA2 from '../../statics/Curriculum/opcionA/foto-POLAROID2.webp';
import imgOpcA3 from '../../statics/Curriculum/opcionA/foto-POLAROID3.webp';
import imgOpcA4 from '../../statics/Curriculum/opcionA/foto-POLAROID4.webp';
import imgOpcA5 from '../../statics/Curriculum/opcionA/foto-POLAROID5.webp';
import imgOpcA6 from '../../statics/Curriculum/opcionA/foto-POLAROID6.webp';

import imgOpcB1 from '../../statics/Curriculum/opcionB/foto-POLAROID1.webp';
import imgOpcB2 from '../../statics/Curriculum/opcionB/foto-POLAROID2.webp';
import imgOpcB3 from '../../statics/Curriculum/opcionB/foto-POLAROID3.webp';
import imgOpcB4 from '../../statics/Curriculum/opcionB/foto-POLAROID4.webp';
import imgOpcB5 from '../../statics/Curriculum/opcionB/foto-POLAROID5.webp';
import imgOpcB6 from '../../statics/Curriculum/opcionB/foto-POLAROID6.webp';

import imgOpcC1 from '../../statics/Curriculum/opcionC/foto-POLAROID1.webp';
import imgOpcC2 from '../../statics/Curriculum/opcionC/foto-POLAROID2.webp';
import imgOpcC3 from '../../statics/Curriculum/opcionC/foto-POLAROID3.webp';
import imgOpcC4 from '../../statics/Curriculum/opcionC/foto-POLAROID4.webp';
import imgOpcC5 from '../../statics/Curriculum/opcionC/foto-POLAROID5.webp';
import imgOpcC6 from '../../statics/Curriculum/opcionC/foto-POLAROID6.webp';

import './CurriculumPage.css';
import ImageModal from './ImageModal';
import VideoPlayer from './VideoPlayer';
import ImageGridV2 from './ImageGridV2';
import ChooseProducts from './ChooseProducts';
import ProductAndDescription from './ProductAndDescription';
import descriptionsInCurriculumsPage from '../../constants/TextCurriculumPage';

function CurriculumPage() {
  const [activeDrawing, setActiveDrawing] = useState(0);
  const { language } = useLanguage();
  const [activeButtonText, setActiveButtonText] = useState('');
  const [activeImageGroup, setActiveImageGroup] = useState(null);
  const [showVideo, setShowVideo] = useState(false);
  const [textVisible, setTextVisible] = useState(false);
  const textRef = useRef(null);
  const audioRef = useRef(new Audio(oceanAudio));
  const [showMenuscroll, setShowMenuscroll] = useState(false);

  const images = [
    { static: activeDrawing === 1 ? image1 : image1Inactive, animated: aniImage1 },
    { static: activeDrawing === 2 ? image2 : image2Inactive, animated: aniImage2 },
    { static: activeDrawing === 3 ? image3 : image3Inactive, animated: aniImage3 },
  ];

  const imageGroups = {
    A: [imgOpcA1, imgOpcA2, imgOpcA3, imgOpcA4, imgOpcA5, imgOpcA6],
    B: [imgOpcB1, imgOpcB2, imgOpcB3, imgOpcB4, imgOpcB5, imgOpcB6],
    C: [imgOpcC1, imgOpcC2, imgOpcC3, imgOpcC4, imgOpcC5, imgOpcC6],
  };

  const videoUrls = {
    A: 'https://player.vimeo.com/video/949518117?autoplay=1&amp;h=3ec1a3b1d8',
    B: 'https://player.vimeo.com/video/949277524?autoplay=1&amp;h=3ec1a3b1d7',
    C: 'https://player.vimeo.com/video/949519346?autoplay=1&amp;h=3ec1a3b1d6',
  };

  const getDescriptionText = useCallback(
    (drawingNumber = activeDrawing) => {
      const key = drawingNumber === 0 ? 'initial' : `drawing${drawingNumber}`;
      return descriptionsInCurriculumsPage[language][key];
    },
    [activeDrawing, language]
  );

  const [descriptionText, setDescriptionText] = useState(getDescriptionText());

  const getPriceForMassage = (drawing) => {
    if (drawing === 0) return "";

    const durations = ["45 min", "60 min", "90 min"];
    const prices = {
      1: ["10000 kr.", "12500 kr.", "14500 kr."],
      2: ["10500 kr.", "13000 kr.", "15000 kr."],
      3: ["12000 kr.", "14500 kr.", "16500 kr."]
    };

    const items = durations.map((dur, i) => (
      <div key={i} className="flex flex-col items-center leading-tight">
        <span style={{ fontSize: '1.28em', fontWeight: '800', color: '#ffd500ff', lineHeight: '1.1' }}>
          {prices[drawing][i]}
        </span>
        <span style={{ fontSize: '0.75em', color: '#cccccc', marginTop: '3px', letterSpacing: '0.6px', fontWeight: '500' }}>
          {dur}
        </span>
      </div>
    ));

    return <div className="flex justify-center gap-7 md:gap-9 mt-3">{items}</div>;
  };

  const handleDrawingClick = (drawingNumber) => {
    const newActive = drawingNumber === activeDrawing ? 0 : drawingNumber;
    if (drawingNumber === activeDrawing) {
      setShowVideo(!showVideo);
    } else {
      setShowVideo(false);
      setActiveDrawing(newActive);
      setActiveButtonText(
        newActive > 0 ? descriptionsInCurriculumsPage[language].buttonText[newActive - 1] : ''
      );
      const groupKey = ['A', 'B', 'C'][drawingNumber - 1];
      setActiveImageGroup(groupKey);
    }
  };

  useEffect(() => {
    const audio = audioRef.current;
    audio.pause();
    audio.muted = true;
  }, []);

  useEffect(() => {
    setDescriptionText(getDescriptionText());
    if (activeDrawing > 0) {
      setActiveButtonText(descriptionsInCurriculumsPage[language].buttonText[activeDrawing - 1]);
    }
  }, [language, activeDrawing, getDescriptionText]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const openModal = (index) => { setActiveImageIndex(index); setIsModalOpen(true); };
  const closeModal = () => setIsModalOpen(false);
  const navigateImages = (direction) => {
    setActiveImageIndex((prevIndex) => {
      const currentImages = imageGroups[activeImageGroup];
      const newIndex = prevIndex + direction;
      if (newIndex < 0) return currentImages.length - 1;
      if (newIndex >= currentImages.length) return 0;
      return newIndex;
    });
  };

  const renderContent = () => {
    if (showVideo && activeImageGroup) {
      return <VideoPlayer videoUrl={videoUrls[activeImageGroup]} />;
    } else {
      return <ImageGridV2 images={imageGroups} activeImageGroup={activeImageGroup} openModal={openModal} />;
    }
  };

  useEffect(() => {
    setTextVisible(!!activeImageGroup);
  }, [activeImageGroup]);

  return (
    <div className="curriculum-page px-2 sm:px-6 lg:px-8">
      <div className="flex justify-between mb-15 sm:mb-22 lg:mb-16">
        <LanguageSelector />
        <img src={logo} alt="Logo" className="w-auto h-10 sm:h-10 lg:h-20" />
      </div>

 <div className="relative min-h-56 mt-8 overflow-hidden">
  <div
    key={descriptionText || "welcome"}
    style={{
      opacity: 0,
      animation: "fadeSlideUp 0.8s ease-out forwards",
      animationDelay: activeDrawing === 0 ? "0.4s" : "0.1s"
    }}
  >
    <ProductAndDescription
      activeButtonText={activeButtonText}
      descriptionText={descriptionText}
      price={getPriceForMassage(activeDrawing)}
    />
  </div>
</div>

      <ChooseProducts
        images={images}
        onDrawingClick={handleDrawingClick}
        activeDrawing={activeDrawing}
        descriptions={descriptionsInCurriculumsPage}
        language={language}
      />

      {activeImageGroup && (
        <>
          {/* ← AQUÍ ESTÁ EL ÚNICO CAMBIO: ahora los dos textos se traducen automáticamente */}
          <div className={`text-center mt-6 mb-1 text-sm italic text-white transition-opacity duration-1000 ${textVisible ? "opacity-100" : "opacity-0"}`}>
            <div className="w-full bg-[#0b1f33]/85 backdrop-blur-sm py-5 px-6 shadow-2xl rounded-2xl border border-white/10">
              <p className="text-white text-sm sm:text-base leading-relaxed font-light whitespace-pre-line italic">
                "{descriptionsInCurriculumsPage[language].timeMessage}"
              </p>
            </div>
          </div>

          {renderContent()}

          <div
            ref={textRef}
            className={`text-center mt-4 mb-1 text-base font-small italic transition-opacity duration-1000 ${textVisible ? 'opacity-100' : 'opacity-0'}`}
          >
            {descriptionsInCurriculumsPage[language].extrasMessage}
          </div>
          {/* ← FIN DEL CAMBIO */}

        </>
      )}

      <ImageModal
        isOpen={isModalOpen}
        images={imageGroups[activeImageGroup]}
        activeIndex={activeImageIndex}
        onClose={closeModal}
        onNavigate={navigateImages}
      />

<footer className="footer text-white py-10 mt-1">
  <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
    <div>

      <div className="text-center mt-1">
  <p className="text-2xl font-bold text-white">
          {language === "es" && "📝 Reserva aquí"}
          {language === "en" && "📝 Book your session"}
          {language === "it" && "📝 Prenota il tuo massaggio"}
          {language === "de" && "📝 Zarezerwuj masaż"}
          {language === "is" && "📝 Bókaðu tíma"}
        </p>

        <p className="text-[1.05rem] font-normal text-white mt-2">
{language === "es" && "Toca la imagen y completa tu reserva"}
{language === "en" && "Tap the button below to complete your booking"}
{language === "it" && "Tocca il pulsante qui sotto per completare la prenotazione"}
{language === "de" && "Dotknij przycisku poniżej, aby dokończyć rezerwację"}
{language === "is" && "Pikkaðu á hnappinn hér fyrir neðan til að ljúka bókuninni"}
        </p>
      </div>

      <div className="mt-4 mb-4 flex justify-center">
        <img
          src={menu}
          alt="Massage Menu"
          className="w-36 cursor-pointer hover:opacity-80 transition"
          onClick={() => setShowMenuscroll(true)}
        />
      </div>

            <div className="h-6"></div>
            <p className="text-center text-white">
{language === "es" && "¿Tienes alguna duda? Escríbeme por WhatsApp 📲"}
{language === "en" && "Questions? Send me a WhatsApp message 📲"}
{language === "it" && "Hai qualche domanda? Scrivimi su WhatsApp 📲"}
{language === "de" && "Masz pytania? Napisz do mnie na WhatsApp 📲"}
{language === "is" && "Ertu með spurningar? Sendu mér skilaboð á WhatsApp 📲"}
              <a href="https://wa.me/3547723840" className="text-green-400 hover:underline font-semibold"
              >
                +354 772-3840
              </a>
            </p>
          </div>

          <div>
            <div className="w-full flex justify-center mt-8 px-4 sm:px-6 lg:px-8">
  <div className="w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-2xl xl:max-w-4xl">
    <img 
      src={promototal} 
      alt="Promociones" 
      className="w-full h-auto"
    />
  </div>
</div>
          <div className="mb-3 sm:mb-20 lg:mb-24"></div>
          <div className="text-center mt-1 mb-10 text-sm italic text-black">
  {descriptionsInCurriculumsPage[language].promoTitle}
  <p className="text-black text-sm">{descriptionsInCurriculumsPage[language].promoLine1}</p>
  <p className="text-black text-sm">{descriptionsInCurriculumsPage[language].promoLine2}</p>
  <div className="text-center mt-4 mb-2 text-base font-medium text-white">
  {descriptionsInCurriculumsPage[language].promoLocation}
</div>
              <iframe
                title="Mapa de ubicación de Islandia"
                className="w-full h-40 rounded-lg mt-2 mb-0"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224792.75312041573!2d-22.678349649999998!3d63.88535079999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4929fd47d3779e53%3A0x5d9cd39cd8c415b7!2sReykjanesb%C3%A6r!5e0!3m2!1ses!2sis!4v1781471904658!5m2!1ses!2sis"
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div>
           <div className={`text-center -mt-6 mb-6 text-sm italic text-black transition-opacity duration-1000 ${textVisible ? "opacity-100" : "opacity-0"}`}>
  <p className="leading-snug">
    {descriptionsInCurriculumsPage[language].mapFooter1}
  </p>
  <p className="leading-snug text-black text-sm italic font-medium">
    {descriptionsInCurriculumsPage[language].mapFooter2}
  </p>
</div>
          </div>

          <div className="text-center mt-1">
  <img 
  src={Me} 
  alt="Sobre mí"
  className="
    w-[65%]       /* móviles */
    sm:w-1/3
    md:w-1/3
    lg:w-1/2      /* PC → 50% (antes 33%) */
    xl:w-[40%]    /* pantallas muy grandes → más equilibrado */
    mx-auto
  "
/>


            <p className="mt-4">{descriptionsInCurriculumsPage[language].aboutMe}</p>
          </div>
        </div>
      </footer>

      {showMenuscroll && (
        <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex justify-center items-start overflow-auto pt-10">
          <div className="relative">
            <button className="absolute top-2 right-2 text-white text-2xl font-bold z-50" onClick={() => setShowMenuscroll(false)}>
              ×
            </button>
            <FormIntake onClose={() => setShowMenuscroll(false)} />
          </div>
        </div>
      )}
    </div>
  );
}

export default CurriculumPage;